import { useEffect, useRef } from "react"
import { useLocation } from "react-router-dom";


declare global {
    interface Window {
        google: any;
    }
}

export const getRedirectURI = () => {
    if (window.location.hostname === "127.0.0.1") {
        return "http://127.0.0.1:3000/login";
    }
    return `${window.location.origin}/login`;
    };

interface GoogleLoginButtonProps {
    text?: string;
}

export const GoogleLoginButton = ({ text = "Ingresa con Google" }: GoogleLoginButtonProps) => {
    const codeClient = useRef<any>(null);
    const location = useLocation(); // Hook de React Router
    const locationInfo = {
            pathname: location.pathname,    // ej: "/dashboard"
            search: location.search,        // ej: "?tab=settings"
            state: location.state,         // cualquier state pasado por navigate()
            key: location.key              // clave única de la location
        };    
    useEffect(() => {
        if(!window.google || codeClient.current) return;
        codeClient.current = window.google.accounts.oauth2.initCodeClient({
            client_id:"821135690153-3qfr9417sq17lcqb6ppi76kkfht0ron3.apps.googleusercontent.com",
            scope:"openid email profile",
            ux_mode:"redirect",
            state: JSON.stringify(locationInfo),
            redirect_uri:getRedirectURI()});
    }, []);

    const handleRedirect = () => {
        if(codeClient.current)
            codeClient.current.requestCode();
    }

    return(
    <button
        id="googleSignInBtn"
        onClick={handleRedirect}
        className="bg-white border rounded flex justify-center items-center gap-2 px-4 py-2 shadow hover:bg-gray-50"
        >
        <img
            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
            alt="Google"
            className="w-5 h-5"
        />
        <span className="text-sm font-medium text-gray-700">{text}</span>
    </button>
    )
}